import styled from 'styled-components';
import { Menu, Dropdown, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import useI18n from '../../common/hooks/useI18n';

const LanguageIcon = styled.span<{ path: string }>`
  width: 22px;
  height: 22px;
  background-image: url(${(props) => props.path});
  background-size: 22px 22px;
  background-repeat: no-repeat;
  background-position: center center;
  cursor: pointer;
  z-index: 1;
`;

const StyledLink = styled.a`
  font-style: ${(props) => props.theme.font.style};
`;

const LanguageSelector = (): JSX.Element => {
  const i18n = useI18n();

  const menu = (
    <Menu>
      <Menu.Item
        key="0"
        onClick={() => {
          i18n.locale('es');
        }}
      >
        <StyledLink>Español</StyledLink>
      </Menu.Item>
      <Menu.Item
        key="1"
        onClick={() => {
          i18n.locale('en');
        }}
      >
        <StyledLink>English</StyledLink>
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <Button
        type="text"
        style={{ display: 'flex', alignItems: 'center', marginLeft: '-10px' }}
        onClick={(e) => e.preventDefault()}
      >
        <LanguageIcon path={i18n.t('languageSelector.language')} />{' '}
        <DownOutlined />
      </Button>
    </Dropdown>
  );
};

export default LanguageSelector;
